// src/components/Login.js
import React from 'react';
import { useAuth } from '../AuthContext';
import {useNavigate} from "react-router-dom"; // Adjust this import path based on where your AuthContext is located

const Login = () => {
    const { login } = useAuth(); // This method should handle the actual authentication logic
    const navigate = useNavigate();
    function authenticate() {
        login();
        navigate('/');
    }
    return (
        <div className="container text-center mt-5">
            <h1>Welcome to Katalyze.ai</h1>
            <button onClick={authenticate} className="btn btn-primary">
                Continue with Google
            </button>
        </div>
    );
};

export default Login;